function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useCallback, useEffect, useMemo, useState } from 'react';
export var useContentOverlay = function useContentOverlay() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDisplayed = _useState2[0],
    setDisplayed = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    scrollPosition = _useState4[0],
    setScrollPosition = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    top = _useState6[0],
    setTop = _useState6[1];
  useEffect(function () {
    var updatePosition = function updatePosition() {
      if (isDisplayed) {
        setScrollPosition(window.pageYOffset);
      } else {
        setScrollPosition(0);
      }
    };
    window.addEventListener('scroll', updatePosition);
    updatePosition();
    return function () {
      return window.removeEventListener('scroll', updatePosition);
    };
  }, [isDisplayed]);
  var open = useCallback(function () {
    var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    setDisplayed(true);
    setTop(pos + scrollPosition);
  }, [scrollPosition]);
  var close = function close() {
    setDisplayed(false);
  };
  var memoizedObject = useMemo(function () {
    return {
      isDisplayed,
      top: "".concat(Math.max(0, top - scrollPosition), "px"),
      close,
      open
    };
  }, [isDisplayed, open, scrollPosition, top]);
  return memoizedObject;
};